import { decode } from "js-base64";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import useBom from "../../hooks/useBom";
import useFileImportStore from "../../stores/fileImportStore";

export default function useBomDetail() {
  const [bomId, setBomId] = useState(null);
  const { encodedBomId } = useParams();
  const { bom, loading } = useBom(bomId);

  useEffect(() => {
    useFileImportStore.getState().setUnParsedBOMs([]);
    useFileImportStore.getState().setCurrentBOMImportIndex(0);
    useFileImportStore.getState().setSuccessfulImports([]);
  }, []);

  useEffect(() => {
    if (encodedBomId) {
      setBomId(decode(encodedBomId));
    } else {
      setBomId(null);
    }

    return () => {
      setBomId(null);
    };
  }, [encodedBomId]);

  return useMemo(() => ({ bom, loading }), [bom, loading]);
}
